import $ from 'jquery'

$(function () {
  $(document).on('click','.footer-links-holder h4', function () {
      $(this).parent().toggleClass('active');
    });
});
